import {axios, API, SendRequest} from '@/imports-files/pages/career/view-job';

export class JobApplication extends SendRequest  {
  async applyJob(params, jobSlug) {
    try {
      const result = await axios.post(API.client.jobs.APPLY_JOB.replace('$job_slug', jobSlug),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async parseCV(params) {
    try {
      const result = await axios.post(API.client.jobs.PARSE_CV,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async confirmEmail(params) {
    try {
      const result = await axios.post(API.client.jobs.CONFIRM_APPLICATION,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async viewApplication(application_id, hostName){
    try {
      const result = await axios.get(API.client.jobs.VIEW_APPLICATION.replace('$application_id', application_id),
          {
            headers: this.serverSideHeaderJSON(hostName)
          },
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async submitAnswers(params, jobSlug) {
    try {
      const result = await axios.post(API.client.jobs.SUBMIT_ANSWERS.replace('$job_slug', jobSlug),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}

